import React from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';

import Settings from '../pages/Commom/Settings';
import ProgramDetails from '../pages/Commom/Programs/ProgramDetails';
import ManagePrograms from '../pages/Commom/Programs/ManagePrograms';
import ListCasters from '../pages/Commom/Casters/ListCasters';
import CreateCaster from '../pages/Commom/Casters/CreateCaster';
import UpdateCaster from '../pages/Commom/Casters/UpdateCaster';
import CreateProgram from '../pages/Commom/Programs/CreateProgram';
import CreateVignettes from '../pages/Commom/CreateVignettes';
import Network from '../pages/Commom/Network';
import EditScript from '../pages/Commom/Scripts/EditScript';
import CreateScript from '../pages/Commom/Scripts/CreateScript';
import Signatures from '../pages/Commom/Signatures';
import Soundtracks from '../pages/Commom/Sountracks';
import Tracks from '../pages/Commom/Tracks';
import WeeklyScripts from '../pages/Commom/Playlists/WeeklyScripts';
import ManagePlaylists from '../pages/Commom/Playlists/ManagePlaylists';
import Offs from '../pages/Commom/Voices/Offs';
import News from '../pages/Commom/Voices/News';
import Blitz from '../pages/Commom/Voices/Blitz';
import Wpps from '../pages/Commom/Voices/Wpps';
import Interviews from '../pages/Commom/Voices/Interviews';
import ManageEpisodes from '../pages/Commom/Episodes/Manage';
import CreateEpisode from '../pages/Commom/Episodes/CreateEpisode';
import CreatedEpisode from '../pages/Commom/Episodes/CreatedEpisode';
import RadioVignettesConfigs from '../pages/Commom/RadioVignettes/RadioVignettesConfigs';
import ListRadioVignettes from '../pages/Commom/RadioVignettes/ListRadioVignettes';

import NotFound from '../pages/Exceptions/_404';

import AppLayout from '../components/Layout';
import { CommomNavigation } from '../components/Navigation';
import { CreateProgramProvider } from '../contexts/CreateProgram';

const CommomStack = () => (
	<BrowserRouter>
		<Switch>
			<Route exact path='/'>
				<Redirect to='/commom/episodes' />
			</Route>

			<Route exact path='/login'>
				<Redirect to='/commom/episodes' />
			</Route>

			<Route exact path='/commom'>
				<Redirect to='/commom/episodes' />
			</Route>

			<Route exact path='/commom/settings'>
				<AppLayout navigation={<CommomNavigation />}>
					<Settings />
				</AppLayout>
			</Route>

			<Route exact path='/commom/radio-vignettes/configs'>
				<AppLayout navigation={<CommomNavigation />}>
					<RadioVignettesConfigs />
				</AppLayout>
			</Route>
			<Route exact path='/commom/radio-vignettes'>
				<AppLayout navigation={<CommomNavigation />}>
					<ListRadioVignettes />
				</AppLayout>
			</Route>

			<Route exact path='/commom/programs'>
				<AppLayout navigation={<CommomNavigation />}>
					<ManagePrograms />
				</AppLayout>
			</Route>
			<Route exact path='/commom/programs/create'>
				<AppLayout navigation={<CommomNavigation />}>
					<CreateProgramProvider>
						<CreateProgram />
					</CreateProgramProvider>
				</AppLayout>
			</Route>
			<Route exact path='/commom/programs/:programId/details'>
				<AppLayout navigation={<CommomNavigation />}>
					<ProgramDetails />
				</AppLayout>
			</Route>
			<Route exact path='/commom/elements/create'>
				<AppLayout navigation={<CommomNavigation />}>
					<CreateVignettes />
				</AppLayout>
			</Route>

			<Route exact path='/commom/network'>
				<AppLayout navigation={<CommomNavigation />}>
					<Network />
				</AppLayout>
			</Route>

			<Route exact path='/commom/casters'>
				<AppLayout navigation={<CommomNavigation />}>
					<ListCasters />
				</AppLayout>
			</Route>
			<Route exact path='/commom/casters/create-caster'>
				<AppLayout navigation={<CommomNavigation />}>
					<CreateCaster />
				</AppLayout>
			</Route>
			<Route exact path='/commom/casters/:casterId/update'>
				<AppLayout navigation={<CommomNavigation />}>
					<UpdateCaster />
				</AppLayout>
			</Route>

			<Route exact path='/commom/soundtracks'>
				<AppLayout navigation={<CommomNavigation />}>
					<Soundtracks />
				</AppLayout>
			</Route>

			<Route exact path='/commom/scripts/:scriptId/edit'>
				<AppLayout navigation={<CommomNavigation />}>
					<EditScript />
				</AppLayout>
			</Route>
			<Route exact path='/commom/scripts/create'>
				<AppLayout navigation={<CommomNavigation />}>
					<CreateScript />
				</AppLayout>
			</Route>

			<Route exact path='/commom/signatures'>
				<AppLayout navigation={<CommomNavigation />}>
					<Signatures />
				</AppLayout>
			</Route>

			<Route exact path='/commom/voices/offs'>
				<AppLayout navigation={<CommomNavigation />}>
					<Offs />
				</AppLayout>
			</Route>
			<Route exact path='/commom/voices/news'>
				<AppLayout navigation={<CommomNavigation />}>
					<News />
				</AppLayout>
			</Route>
			<Route exact path='/commom/voices/blitz'>
				<AppLayout navigation={<CommomNavigation />}>
					<Blitz />
				</AppLayout>
			</Route>
			<Route exact path='/commom/voices/wpps'>
				<AppLayout navigation={<CommomNavigation />}>
					<Wpps />
				</AppLayout>
			</Route>
			<Route exact path='/commom/voices/interviews'>
				<AppLayout navigation={<CommomNavigation />}>
					<Interviews />
				</AppLayout>
			</Route>

			<Route exact path='/commom/playlists'>
				<AppLayout navigation={<CommomNavigation />}>
					<ManagePlaylists />
				</AppLayout>
			</Route>
			<Route exact path='/commom/playlists/weekly-scripts'>
				<AppLayout navigation={<CommomNavigation />}>
					<WeeklyScripts />
				</AppLayout>
			</Route>

			<Route exact path='/commom/tracks'>
				<AppLayout navigation={<CommomNavigation />}>
					<Tracks />
				</AppLayout>
			</Route>

			<Route exact path='/commom/episodes'>
				<AppLayout navigation={<CommomNavigation />}>
					<ManageEpisodes />
				</AppLayout>
			</Route>
			<Route exact path='/commom/episodes/create-episode'>
				<AppLayout navigation={<CommomNavigation />}>
					<CreateEpisode />
				</AppLayout>
			</Route>
			<Route exact path='/commom/episodes/:episodeId/details'>
				<AppLayout navigation={<CommomNavigation />}>
					<CreatedEpisode />
				</AppLayout>
			</Route>

			<Route exact path='*'>
				<NotFound />
			</Route>
		</Switch>
	</BrowserRouter>
);

export default CommomStack;
